import * as Ariakit from '@ariakit/react';
import { getClassNames } from '@websolutespa/bom-core';
import { ReactNode, useContext } from 'react';
import styled from 'styled-components';
import { getVariantKey, useVariants } from '../../variants';
import { UIStyledComponentProps } from '../types';
import { getCssResponsive } from '../utils';
import { AccordionGroupContext } from './accordion-group.context';
import { AccordionProvider } from './accordion.context';
import { accordionVariants, IAccordionVariants } from './accordion.variants';

const AccordionStyle = styled.div <AccordionProps>`
  ${props => getVariantKey('accordion', props.variant, props.variants)}
  ${props => getCssResponsive(props)}
`;

export type AccordionProps = Ariakit.DisclosureProviderProps & UIStyledComponentProps<{
  index?: number;
  className?: string;
  variant?: keyof typeof accordionVariants | (string & {});
  variants?: IAccordionVariants;
  children?: ReactNode;
}>;

export function Accordion({
  index,
  className,
  variant,
  variants,
  children,
  open,
  defaultOpen,
  setOpen,
  setMounted,
  ...props
}: AccordionProps) {
  const context = useContext(AccordionGroupContext);
  const globalVariants = useVariants('accordion', accordionVariants);
  variant = variant || context?.variant || 'default';
  variants = variants || context?.variants || globalVariants;
  const classNames = getClassNames('accordion', className);
  return (
    <AccordionProvider value={{
      variant,
      variants,
    }}>
      <Ariakit.DisclosureProvider
        open={open}
        defaultOpen={defaultOpen}
        setOpen={setOpen}
        setMounted={setMounted}
      >
        <AccordionStyle
          className={classNames}
          variant={variant}
          variants={variants}
          {...props}
        >
          {children}
        </AccordionStyle>
      </Ariakit.DisclosureProvider>
    </AccordionProvider>
  );
}
